import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, downloadUrl: String, title: String }

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  open() {
    // Find the global modal
    const modal = document.getElementById('image-modal')
    const image = modal?.querySelector('[data-target="image"]')
    const downloadLink = modal?.querySelector('[data-target="download-link"]')
    
    if (!modal || !image || !downloadLink) return
    
    image.src = this.urlValue
    image.alt = this.titleValue + ' - Album Artwork'
    downloadLink.href = this.downloadUrlValue
    
    modal.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
    document.addEventListener('keydown', this.boundHandleKeydown)
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeModal()
    }
  }

  closeModal() {
    const modal = document.getElementById('image-modal')
    if (!modal) return
    
    modal.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
    document.removeEventListener('keydown', this.boundHandleKeydown)
  }


  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeydown)
  }
}